export default __webpack_public_path__ + "static/media/TKIgroup.b22db72b.jpg";